// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ArticleSearch":"bav_a bhr_ea bhr_sn","ArticleSearch__items":"bav_b bhr_tg","ArticleSearch__item":"bav_c bhr_th"};